window.addEventListener("DOMContentLoaded", function() {
  const sliders = document.querySelectorAll('.c-aggregator--slider');
  const edit_mode = document.querySelector('body.i4-template--edit-mode');
  if (sliders.length) {
    if (edit_mode == null) {
      aggregatorsliderInit(sliders);
    } else {
      console.log('Slider Disabled in Edit Mode');
    }
  }
});

function aggregatorsliderInit(sliders) {
  var body = document.querySelector('body');

  try {
    /* slick is defined in view mode only */
    for (let i = 0; i < sliders.length; i++) {
      if (sliders[i].classList.contains('c-aggregator--videoblog')) {
        $(sliders[i]).slick({
          dots: true,
          centerMode: false,
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: '<div class="slider--controller-left"><svg><use xlink:href="#svg-sprite-project-icon-slide-left"/></svg></div>',
          nextArrow: '<div class="slider--controller-right"><svg><use xlink:href="#svg-sprite-project-icon-slide-right"/></svg></div>',
          responsive: [
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      } else if (sliders[i].classList.contains('c-aggregator--referenzen')) {
        $(sliders[i]).slick({
          dots: true,
          centerMode: false,
          speed: 1000,
          autoplay: true,
          autoplaySpeed: 3000,
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          prevArrow: null,
          nextArrow: null,
          responsive: [
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      } else if (sliders[i].classList.contains('c-aggregator--testimonials')) {
        $(sliders[i]).slick({
          dots: true,
          centerMode: false,
          speed: 1000,
          autoplay: true,
          autoplaySpeed: 3000,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: '<div class="slider--controller-left"><svg><use xlink:href="#svg-sprite-project-icon-slide-left"/></svg></div>',
          nextArrow: '<div class="slider--controller-right"><svg><use xlink:href="#svg-sprite-project-icon-slide-right"/></svg></div>',
          // responsive: [
          //   {
          //     breakpoint: 800,
          //     settings: {
          //       slidesToShow: 1,
          //       slidesToScroll: 1
          //     }
          //   },
          //   {
          //     breakpoint: 480,
          //     settings: {
          //       slidesToShow: 1,
          //       slidesToScroll: 1
          //     }
          //   }
          // ]
        });
      } else {
        $(sliders[i]).slick({
          dots: true,
          centerMode: false,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          prevArrow: '<div class="slider--controller-left"><svg><use xlink:href="#svg-sprite-project-icon-slide-left"/></svg></div>',
          nextArrow: '<div class="slider--controller-right"><svg><use xlink:href="#svg-sprite-project-icon-slide-right"/></svg></div>',
          responsive: [
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }

      var $title = $(sliders[i]).closest('.c-aggregator__item--aggregator_wrapper').prev().find('h2'); // use jquery as .closest() does not work in IE11
      $title.addClass('slider-title');
    }
  } catch(e) {
    console.log(e);
  }
}
